/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('gesturestart', function(e) {
    e.preventDefault();
    // special hack to prevent zoom-to-tabs gesture in safari
    document.body.style.zoom = 0.99;
});

document.addEventListener('gesturechange', function(e) {
    e.preventDefault();
    // special hack to prevent zoom-to-tabs gesture in safari
    document.body.style.zoom = 0.99;
});

document.addEventListener('gestureend', function(e) {
    e.preventDefault();
    // special hack to prevent zoom-to-tabs gesture in safari
    document.body.style.zoom = 0.99;
});

/*
$(function(){
  

if ($("body").hasClass("template--collection") && (console.log("test"), window.matchMedia("(max-width: 740px)").matches)) {
    let pInfScrExecute2 = function() {
        if ($("product-list.product-facet__product-list").height() - 400 < $(document).scrollTop()) {
            var loadingImage;
            pInfScrNode = $(".product-list__inner").last().find(".more").last(), pInfScrURL = $(".product-list__inner").last().find(".more a").last().attr("href"), !pInfScrLoading && pInfScrNode.length > 0 && ($(".product-list").append('<img src="https://cdn.shopify.com/s/files/1/0028/9806/7554/files/Spinner-1s-200px.gif?v=1692351513" class="loading" />'), $.ajax({
                type: "GET",
                url: pInfScrURL,
                beforeSend: function() {
                    pInfScrLoading = !0, loadingImage = pInfScrNode.clone().empty().append(""), loadingImage.insertAfter(pInfScrNode), pInfScrNode.hide(), console.log("loading...")
                },
                success: function(data) {
                    pInfScrNode.next().remove();
                    var filteredData = $(data).find(".product-list__inner");
                    $(".product-list__inner.grid_view_custom").find(".more").before(filteredData.html()), $(".product-list__inner.grid_view_custom").find(".more").html(filteredData.find(".more").html()), loadingImage.remove(), $(".product-list").find(".loading").remove(), pInfScrLoading = !1, document.dispatchEvent(new CustomEvent("swym:collections-loaded"))
                },
                dataType: "html"
            }))
        }
    };
    var pInfScrExecute = pInfScrExecute2,
        pInfScrLoading = !1,
        pInfScrDelay = 100;
    $(document).ready(function() {
        $(window).scroll(function() {
            $.doTimeout("scroll", pInfScrDelay, pInfScrExecute2), $("product-list.product-facet__product-list").height() - 400 < $(document).scrollTop() && (pInfScrDelay = 20)
        })
    })
}
})
*/
// script.js
document.addEventListener('DOMContentLoaded', () => {
      // Function to check if touch is outside the target div
    function handleTouchStart(event) {
      const touch = event.touches[0]; // Get the first touch point
      const touchX = touch.clientX;
      const touchY = touch.clientY;
      const targetDiv = document.getElementsByClassName('scroclass v-options')[0];
      if(!targetDiv) return '';
      // Get the target div's bounding rectangle
      const rect = targetDiv.getBoundingClientRect();

      // Check if the touch is outside the target div
      if (
        touchX < rect.left || 
        touchX > rect.right || 
        touchY < rect.top || 
        touchY > rect.bottom
      ) {
       // targetDiv.classList.add('hidden'); // Add hidden class
                       //   targetDiv.classList.remove('scroclass');
                         //document.body.classList.remove('stop-scroll');
      }
    }

    // Add event listener to document for touch events
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
  
    const swipeables = document.querySelectorAll('.closebtncs');

    swipeables.forEach(swipeable => {

              let startY;
        let isSwiping = false;
                    const parent = swipeable.parentElement; // Get the parent element

        swipeable.addEventListener('touchstart', (e) => {
            startY = e.touches[0].clientY;
            isSwiping = true;
        });
              swipeable.addEventListener('touchmove', (e) => {
            if (isSwiping) {
                const currentY = e.touches[0].clientY;
                const distanceY = currentY - startY;

                if (distanceY > 50) { // Adjust threshold as needed
                    parent.style.transform = `translateY(${distanceY}px)`;
                }
            }
        });

        swipeable.addEventListener('touchend', () => {
            if (isSwiping) {
                const distanceY = parseFloat(getComputedStyle(swipeable).transform.split(',')[5] || 0);
                if (distanceY > 100) { // Adjust threshold as needed
                    parent.classList.add('close');
                } else {
                    parent.style.transform = 'translateY(0)';
                }
              setTimeout(() => {
                    parent.style.display = 'none'; // Optionally set display to none after the transition
                         //    $('.v-options').removeClass('scroclass');
                  
                  parent.classList.remove('scroclass');
                          document.body.classList.remove('stop-scroll'); // Remove the 'dark-theme' class from the body


                }, 300); // Match the duration of the transition
              
                isSwiping = false;
            }
        });
      /*
        swipeable.addEventListener('touchend', (e) => {
            const endX = e.changedTouches[0].clientX;

          

            if (startX - endX > 50) { // Adjust swipe threshold as needed
                parent.style.transform = 'translateX(-100%)'; // Hide the div by translating it out of view
                setTimeout(() => {
                    parent.style.display = 'none'; // Optionally set display to none after the transition
                         //    $('.v-options').removeClass('scroclass');
                  
                  parent.classList.remove('scroclass');
                          document.body.classList.remove('stop-scroll'); // Remove the 'dark-theme' class from the body


                }, 300); // Match the duration of the transition
              
            }
        });
        */
      
    });
});

$(function(){
 function swiper_slider_init(selector) {
			  if(selector.length !=0) {
				  selector.each(function(index){
					  var slider_id ='#'+jQuery(this).attr('id');
				  
					  var swiper = new Swiper(slider_id, {
						  slidesPerView: 1,
                        	      lazy: true,

						   loop: true,
	   						pagination: {
        						el: '.swiper-pagination',
								clickable: true,
      						},
                        
						});						
				  })
			  }
		  }
		 									swiper_slider_init($('.mySwiper'));
  $(document).on('click','.faq__item .collapsible-toggle',function(){
    var grandParent = $(this).parents('.faq__wrapper-1');
    var parent = $(this).parent();
    grandParent.find('.collapsible-toggle').not($(this)).attr('aria-expanded',false);
    grandParent.find('.collapsible').not(parent.find('.collapsible')).removeAttr('open');
 //   console.log($(this),parent);
  });

  function isInViewport(element) {
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).outerHeight();
        
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }
    function isFooterVisible() {
      const footer = document.getElementsByClassName('shopify-section--footer')[0];
      const footerRect = footer.getBoundingClientRect();
    // console.log(footerRect,window.innerHeight);
      return footerRect.top <= 600;
    }

    function checkVisibilityOnScroll() {
          if($(window).width() < 1200 ){
          //  console.log(isFooterVisible());
        $('.blr-mh-color').each(function() {
            if (isInViewport(this)) {

              var isHome= $('body').hasClass('index');
              if(isFooterVisible() && isHome) {
               $('.shopify-section--header').css('transform','translateY(-100%)');
              }
              else {
               $('.shopify-section--header').css('transform','translateY(0)');
              }
                // Element is in the viewport
            //    console.log($(this).attr('class') + ' is visible');
                // Add your logic here (e.g., add a class, trigger an event)
            } else {
                // Element is out of the viewport
               // console.log($(this).attr('class') + ' is not visible');
            }
        });
          }
    }

    // Listen to scroll event
    //    $(window).on('scroll', checkVisibilityOnScroll);
    
        // You might also want to check on page load
      //  $(window).on('load', checkVisibilityOnScroll);
    
    document.addEventListener("DOMContentLoaded", function () {
      document.body.innerHTML = document.body.innerHTML.replace(/T-Shirt/g, 'T\u2011Shirt');
    });
})
